/* infant-funnel-events.js
 * Unified Meta Pixel + Google Ads funnel-event emitter for the Yuva theme.
 *
 * Fires on real user actions:
 *   • product form submit (.main-product-form / form[action="/cart/add"])  → AddToCart / add_to_cart
 *   • checkout button click  (a[href*="/checkout"], button[name="checkout"])  → InitiateCheckout / begin_checkout
 *
 * Reads product context from Yuva's hidden product-form fields when available;
 * falls back to a generic event with no payload so something still fires.
 *
 * Why custom: Shopify's hosted checkout page is iframed/cross-domain — gtag/fbq
 * loaded on the storefront don't see checkout actions, so we have to fire those
 * funnel signals client-side ourselves before the user navigates away.
 *
 * Safe: every call wrapped in try/catch — must NEVER break add-to-cart.
 */
(function () {
  var GA_ADD_TO_CART = 'AW-384857606/SCDRCI2SjYQCEIbswbcB';
  var GA_BEGIN_CHECKOUT = 'AW-384857606/1apeCJCSjYQCEIbswbcB';

  function fire(name, attempt) {
    attempt = attempt || 0;
    // wait up to 2s for fbq/gtag to bootstrap before giving up
    if (typeof window.fbq === 'undefined' && typeof window.gtag === 'undefined' && attempt < 20) {
      setTimeout(function () { fire(name, attempt + 1); }, 100);
      return;
    }
    try { name(); } catch (_) { /* swallow */ }
  }

  function readProductCtx(form) {
    try {
      var hidden = form && form.querySelector('input[name="id"]');
      var id = hidden ? hidden.value : null;
      // Yuva embeds JSON in <script type="application/json" data-selected-variant>
      var jsonEl = document.querySelector('script[data-selected-variant], script[type="application/json"][data-product-json]');
      var data = null;
      if (jsonEl) {
        try { data = JSON.parse(jsonEl.textContent || jsonEl.innerText || '{}'); } catch (_) {}
      }
      var price = data ? (data.price || data.compare_at_price) : null;
      var title = data ? data.title : null;
      return {
        id: id,
        price: price ? (price / 100.0) : undefined,
        title: title || (document.querySelector('h1') || document.querySelector('h2') || {}).textContent,
      };
    } catch (_) { return {}; }
  }

  function emitAddToCart(form) {
    var ctx = readProductCtx(form);
    fire(function () {
      if (window.fbq) {
        window.fbq('track', 'AddToCart', {
          content_type: 'product',
          content_ids: ctx.id ? [String(ctx.id)] : undefined,
          content_name: ctx.title,
          value: ctx.price,
          currency: 'RON'
        });
      }
      if (window.gtag) {
        window.gtag('event', 'add_to_cart', {
          send_to: GA_ADD_TO_CART,
          value: ctx.price,
          currency: 'RON',
          items: ctx.id ? [{ id: String(ctx.id), google_business_vertical: 'retail' }] : []
        });
      }
    });
  }

  function readCartTotal() {
    try {
      // Yuva exposes window.theme or .cart_total spans
      var el = document.querySelector('[data-cart-total], .cart-total, .total-price, [data-checkout-price]');
      if (el) {
        var txt = (el.textContent || el.getAttribute('data-cart-total') || '').replace(/[^0-9.,]/g, '').replace(',', '.');
        var n = parseFloat(txt);
        if (!isNaN(n) && n > 0) return n;
      }
    } catch (_) {}
    return undefined;
  }

  function emitInitiateCheckout() {
    var value = readCartTotal();
    fire(function () {
      if (window.fbq) {
        window.fbq('track', 'InitiateCheckout', { currency: 'RON', value: value });
      }
      if (window.gtag) {
        window.gtag('event', 'begin_checkout', {
          send_to: GA_BEGIN_CHECKOUT,
          currency: 'RON',
          value: value
        });
      }
    });
  }

  function bind() {
    // Capture-phase submit on any product form
    document.addEventListener('submit', function (e) {
      try {
        var f = e.target;
        if (!f || f.tagName !== 'FORM') return;
        var act = (f.getAttribute('action') || '');
        if (act.indexOf('/cart/add') === -1) return;
        emitAddToCart(f);
      } catch (_) {}
    }, true);

    // Checkout click — covers cart-page button, drawer button, sticky bar
    document.addEventListener('click', function (e) {
      try {
        var t = e.target;
        while (t && t !== document) {
          var tag = (t.tagName || '').toLowerCase();
          if (tag === 'a' || tag === 'button') {
            var href = (t.getAttribute && t.getAttribute('href')) || '';
            var name = (t.getAttribute && t.getAttribute('name')) || '';
            var txt = (t.textContent || '').toLowerCase();
            if (href.indexOf('/checkout') !== -1 || name === 'checkout' ||
                txt.indexOf('finalizează') !== -1 || txt.indexOf('finalizeaza') !== -1 ||
                txt.indexOf('checkout') !== -1 || txt.indexOf('plată') !== -1 || txt.indexOf('plata') !== -1) {
              emitInitiateCheckout();
              break;
            }
          }
          t = t.parentNode;
        }
      } catch (_) {}
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
